import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { VBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { CompanyStatusCard } from '../components/StatusLabel';
import { KanbanProgressBar } from '../../KanbanBoards/components/ProgressBar';
import { fetchUser } from '../../Users/actions';
import { selectUserId, selectWork } from '../../Api/selectors';
import { selectUser } from '../../Users/selectors';
import { REQUEST_USER } from '../../Users/constants';
import { getDate } from '../../Vehicles/helpers';
import { getPropertyValueObjectByName, getPropByName } from '../../../utils/props';
import styles from './CardInfo.module.css';
import cn from 'classnames';
import { makeSelectLocale } from '../../../containers/LanguageProvider/selectors';
import { translateCountry } from '../translate-countries';

const Container = styled.div`
  .kanbanProgressBar {
    margin: 12px 0;
  }
  .address {
    color: #888;
  }
  .type {
    color: #6c757d;
  }
  .regplate {
  }
`;

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class CompanyInfoCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (this.props.company?.user_changed_status) {
      this.props.fetch(this.props.company?.user_changed_status, result => this.setState({ user: result }));
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.company?.user_changed_status !== this.props.company?.user_changed_status) {
      this.props.fetch(this.props.company?.user_changed_status, result => this.setState({ user: result }));
    }
  }

  get statusUpdatedAt() {
    const date = getPropertyValueObjectByName(this.props.company, 'status', '', 'updatedAt');

    const parsedDate = getDate(date, true);
    return parsedDate;
  }

  get userChangedStatus() {
    let name = this.state.user ? getPropByName(this.state.user, 'name') : this.props.changedStatusUser?.name || '';

    let surname = this.state.user ? getPropByName(this.state.user, 'surname') : this.props.changedStatusUser?.surname || '';
    return `${name} ${surname}`;
  }

  get statusRemark() {
    if (!this.props.company?.status_remark) return '';

    return `${this.props.company?.status_remark}`;
  }

  get homeAddress() {
    const address = this.props.company.addresses?.find(a => a.type?.name === 'home');

    return address;
  }

  get country() {
    return translateCountry(this.homeAddress?.country?.name, this.locale);
  }

  get locale() {
    return this.props.locale;
  }

  render() {
    const company = this.props.company;

    return (
      <Card className="company-info-card info-card info">
        <Container>
          <div className={styles.title}>
            {company['company_type'] === 'company'
              ? `${company['name'] || ''} `
              : `${company['name'] || ''} ${company['surname'] ? company['surname'] : ''}`}
          </div>

          <div className={cn('address', styles.address)}>
            {this.homeAddress?.addressLine1}&nbsp;{this.homeAddress?.zipcode}&nbsp;{this.homeAddress?.city}&nbsp;
            {this.country}
          </div>

          {company.status && (
            <CompanyStatusCard
              setStatusLogs={'true'}
              loggedInUserId={this.props.loggedInUserId}
              company={company}
              status={company.status}
            >
              {this.lbl(`company.property.status.${company.status}`)}
            </CompanyStatusCard>
          )}

          <div>
            {this.statusUpdatedAt || ''}
            {company?.user_changed_status && (
              <p style={{ margin: '0px' }}>
                {this.lbl('vehicle.details.status_log.filled_by')} &nbsp;
                {this.userChangedStatus}
              </p>
            )}
            {this.statusRemark?.trim()?.length >= 1 && (
              <p style={{ margin: '0px' }}>
                {this.lbl('vehicle.details.status_log.remark')}: &nbsp;
                {this.statusRemark}
              </p>
            )}
          </div>
        </Container>
      </Card>
    );
  }
}

CompanyInfoCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loggedInUserId: selectUserId(),
    changedStatusUser: selectUser(ownProps?.company?.user_changed_status),
    work: selectWork(REQUEST_USER),
    locale: makeSelectLocale(),
  });
function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch(id, callback) {
      dispatch(fetchUser(id, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyInfoCard = compose(withConnect, withRouter)(CompanyInfoCardComp);
